import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  isLoggedIn: false,
};

export const homeworkReducer = createReducer(initialState, {
  [types.HOMEWORK_RESPONSE](state, action) {
    return {
      ...state,
      data: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.HOMEWORK_DETAILS_RESPONSE](state, action) {
    return {
      ...state,
      detailData: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
